import { sendPost } from './axios';

export const register = (payload) => sendPost(`/auth/register`, payload);

export const login = (payload) => sendPost(`/auth/login`, payload);

export const verify = (payload) => sendPost(`/auth/verify-otp`, payload);

export const updateOtpInfo = (payload) => sendPost(`/auth/update-otp-info`, payload);

export const checkUserExisting = (payload) => sendPost(`/auth/check-user-existing`, payload);